import _ from 'lodash-es';

/* globals google */

export default class ModalPostalAddressController {
	/* @ngInject */
	/**
	 * @param {any} AddressService
	 * @param {any} NgMap
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} address
	 * @param {any} disabled
	 */
	constructor(
		AddressService,
		NgMap,
		NodeService,
		$scope,
		$timeout,
		$translate,
		$uibModalInstance,
		address,
		disabled,
	) {
		this.$uibModalInstance = $uibModalInstance;

		const Address = AddressService;
		this.address = address instanceof Address.constructor ? address : Address.set(address);
		this.disabled = disabled;
		this.formName = $translate.instant('form.new-postal-address');
		this.advanced = false;
		this.geocoder = new window.google.maps.Geocoder(); // jshint ignore:line
		/** @type {?google.maps.Map} */
		this.map = null;
		this.setAutoPositionFromMap = true;
		this.zoom = 17;

		(async () => {
			this.map = await NgMap.getMap();
		})();

		$scope.$watch('$ctrl.address.country', (/** @type {any} */ newCountry, /** @type {any} */ oldCountry) => {
			if (!_.isEqual(newCountry, oldCountry) && newCountry && newCountry.length === 1) {
				NodeService.load(newCountry[0].kid).then(node => {
					if (node) {
						// @ts-ignore
						const code = node.getRepre('K_NODE;CODE');

						if (code) {
							this.address.street_number = undefined;
							this.address.route = undefined;
							this.address.route2 = undefined;
							this.address.postal_box = undefined;
							this.address.cedex = undefined;
							this.address.postal_code = undefined;
							this.address.locality = undefined;
							this.address.administrative_area_level_1 = undefined;
							this.address.administrative_area_level_2 = undefined;
							return this.updateLocationMap({ address: `country:${code.value}` });
						}
					}
					return false;
				}).catch((/** @type {any} */ error) => console.error(error));
			}
		}, true);

		$scope.$watchGroup([
			'$ctrl.address.street_number',
			'$ctrl.address.route',
			'$ctrl.address.postal_code',
			'$ctrl.address.locality',
			'$ctrl.address.administrative_area_level_1',
			'$ctrl.address.administrative_area_level_2',
		], (/** @type {any} */ newValue, /** @type {any} */ oldValue) => {
			if (this.setAutoPositionFromMap && !_.isEqual(newValue, oldValue)) {
				this.updateLocationMap({ address: this.address.toString() });
			}
		});

		// eslint-disable-next-line unicorn/no-this-assignment
		const self = this;
		this.updateLocationHandler = function updateLocationHandler(/** @type {google.maps.event} */ event) {
			self.updateLocation(event);
		};
		this.updateZoomHandler = function updateZoomHandler() {
			self.updateZoom();
		};
		$timeout(() => $scope.$apply(), 1000);
	}

	cancel() {
		this.$uibModalInstance.dismiss();
	}

	/**
	 * @param {any} address
	 */
	submit(address) {
		this.$uibModalInstance.close(address);
	}

	/**
	 * @param {google.maps.event} event
	 */
	updateLocation(event) {
		if (!this.disabled) {
			this.setAutoPositionFromMap = false;
			// @ts-ignore
			this.address.location.lat = event.latLng.lat();
			// @ts-ignore
			this.address.location.lng = event.latLng.lng();
		}
	}

	/**
	 * @param {google.maps.GeocoderRequest} request
	 * @returns {any}
	 */
	updateLocationMap(request) {
		if (this.disabled) {
			return;
		}

		this.geocoder.geocode(request, (result, status) => {
			if (status === window.google.maps.GeocoderStatus.OK && result?.length === 1) {
				this.address.location.lat = result[0].geometry.location.lat();
				this.address.location.lng = result[0].geometry.location.lng();

				for (const component of result[0].address_components) {
					if ('administrative_area_level_1' in component.types) {
						this.address.administrative_area_level_1 = component.long_name;
					}
					else if ('administrative_area_level_2' in component.types) {
						this.address.administrative_area_level_2 = component.long_name;
					}
				}

				this.map?.fitBounds(result[0].geometry.viewport);
			}
		});
	}

	updateZoom() {
		if (!this.disabled) {
			this.address.location.zoom = this.zoom;
		}
	}
}
